require("./common/init").init();